import { Mapper } from "../../../../base/utils/mapper";
import { TypeModalityModel } from "../../../../domain/models/consult/type-modality.model";
import { TypeModalityEntity } from "../entities/type-modality.entity";


export class TypeModalityImplementationRepositoryMapper extends Mapper<TypeModalityEntity, TypeModalityModel> {
    mapFrom(param: TypeModalityEntity): TypeModalityModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: TypeModalityModel): TypeModalityEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}